(ns app.front.view.meetings.core
  (:require [app.domain.committee.model :as committee-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.party.model :as party-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entity-edit :as ee]
            [app.front.process :as process]
            [app.front.query.process :as process-query]
            [app.front.ui :as ui]
            [app.front.ui.action-bar :as ui-action-bar]
            [app.front.ui.add-widget :as ui-add]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.util :as futil]
            [app.front.view.committees.common :as committee-common]
            [app.front.view.committees.core :as committee-view]
            [app.front.view.committees.subs :as committee-subs]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.meetings.subs :as meetings-subs]
            [app.rich-text :as rich-text]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]
            [schema.core :as s]))

;; TODO: This can be removed and the localization changed once :feature-flag.id/domain-level-meetings is removed.
(defn- translate-action [tr action-kw]
  (if (= action-kw :committee-item.selected-action/passed)
    (tr [:committee-meeting/completed])
    (tr [action-kw])))

(defn add-meeting [{:keys [group-id]}]
  (r/with-let [committees (<sub [::committee-subs/committees-in-group group-id true])
               *params    (r/atom {:committee nil})
               set-val    (partial swap! *params assoc)]
    (let [tr                                      (<sub [:tr])
          lang                                    (<sub [:language])
          {:keys [:committee-meeting/date
                  :committee-meeting/description]
           :as   params}                          @*params
          selected-committee                      (:committee params)
          schedule-day                            (:committee/schedule-day-of-week selected-committee)
          schedule-frequency                      (:committee/schedule-frequency selected-committee)
          schedule-period                         (:committee/schedule-period selected-committee)
          disabled?                               (or (-> params :committee-meeting/date nil?)
                                                      (-> params :committee nil?))]
      [:div.mb-4
       [ui-add/add-widget
        {:title   [:span.normal-case (tr [:meetings/create-meeting-title])]
         :buttons [{:text     (tr [:cancel])
                    :on-click #(>evt [::committee-subs/hide-add-meeting nil])}
                   {:disabled? disabled?
                    :on-click  #(>evt [::committee-subs/create-meeting
                                       (-> params
                                           (dissoc :committee)
                                           (assoc :committee-id
                                                  (-> params :committee :db/id)
                                                  :origin :meetings-view)
                                           (cond->
                                             (nil? (:committee-meeting/meeting-agenda-template-ref params))
                                             (dissoc :committee-meeting/meeting-agenda-template-ref)
                                             (some? (:committee-meeting/meeting-agenda-template-ref params))
                                             (update :committee-meeting/meeting-agenda-template-ref :db/id)))])
                    :text      (tr [:meetings/done])}]}

        ;; Row 1: Meeting type + Agenda Template
        [:div.flex.flex-row.gap-4
         [:div.flex-1
          [ui-select/select {:id           "add-meeting-committee-id"
                             :class-name   "full-width-select"
                             :label-text   (tr [:committee/meeting-type])
                             :hide-label   false
                             :required     true
                             :allow-empty? false
                             :value        (:committee params)
                             :values       committees
                             :val->str     #(committee-model/committee-name % lang)
                             :on-change    (fn [c]
                                             (set-val :committee c)
                                             (set-val :committee-meeting/meeting-agenda-template-ref nil))}]]
         (let [default-template (:committee/meeting-agenda-template-ref selected-committee)
               all-templates    (<sub [::committee-subs/available-meeting-agenda-templates group-id])
               templates        (remove #(= (:db/id %) (:db/id default-template)) all-templates)
               selected         (:committee-meeting/meeting-agenda-template-ref params)]
           [:div.flex-1
            [ui-select/select {:id           "add-meeting-agenda-template"
                               :class-name   "full-width-select"
                               :label-text   (tr [:meetings/agenda-template])
                               :hide-label   false
                               :allow-empty? true
                               :disabled     (nil? selected-committee)
                               :select-text  (if default-template
                                               (str (tr [:meetings/default-template])
                                                    " (" (:meeting-agenda-template/name default-template) ")")
                                               (tr [:meetings/select-template]))
                               :value        selected
                               :values       templates
                               :val->str     :meeting-agenda-template/name
                               :on-change    #(set-val :committee-meeting/meeting-agenda-template-ref %)}]])]

        ;; Separator above Date row
        [:hr.border-t.border-solid.border-ui-gray.my-4]

        ;; Row 2: Date + Time + Read-only recurrence from meeting type
        [:div.flex.flex-row.gap-4.items-end
         [:div.flex-1
          [ui/date-picker {:label-text (tr [:meetings/date])
                           :required?  true
                           :min-date   (date-util/today-start-of-day)
                           :callback   #(set-val :committee-meeting/date
                                                 (if (and date (some? %))
                                                   (date-util/set-hours-and-minutes % (.getHours date) (.getMinutes date))
                                                   %))
                           :value      date}]]
         [:div.flex-1
          [ui/time-input {:label-text (tr [:meetings/time])
                          :on-change  (fn [[hour minute]]
                                        (set-val
                                          :committee-meeting/date
                                          (date-util/set-hours-and-minutes
                                            (or (date-util/start-of-day date) (js/Date.))
                                            hour
                                            minute)))
                          :value      (if date
                                        [(.getHours date) (.getMinutes date)]
                                        [12 0])}]]
         [:div.flex-1
          [:label.bx--label (tr [:meetings/recurrence])]
          (if selected-committee
            [:div.py-2
             (if (and schedule-frequency schedule-period)
               (str (tr [:meetings/repeat-every]) " "
                    schedule-frequency " "
                    (futil/tr-date-frequency tr (name schedule-period))
                    (when schedule-day
                      (str ", " (futil/tr-weekday tr (str (mod (inc schedule-day) 7))))))
               (tr [:meetings/no-recurrence]))]
            [:div.py-2.text-gray-400
             (tr [:meetings/select-type-for-recurrence])])]]

        ;; Notes
        [:div
         [:label.bx--label (tr [:meetings/notes])]
         [ui-rt/editor {:initial-value description
                        :id            "new-meeting-description"
                        :on-change     #(set-val :committee-meeting/description %)}]]]])))

(defn- edit-meeting [{:keys [meeting]}]
  (let [tr               (<sub [:tr])
        meeting-id       (:db/id meeting)
        date             (<sub [::ee/attr-value meeting-id :committee-meeting/date])
        disabled?        (nil? date)
        committee        (:entity/parent meeting)
        group-id         (-> committee :entity/parent :db/id)
        default-template (:committee/meeting-agenda-template-ref committee)
        all-templates    (<sub [::committee-subs/available-meeting-agenda-templates group-id])
        templates        (remove #(= (:db/id %) (:db/id default-template)) all-templates)
        unsaved          (<sub [::ee/unsaved-for meeting-id])
        has-tmpl-change? (contains? unsaved :committee-meeting/meeting-agenda-template-ref)
        current-template (if has-tmpl-change?
                           (let [v (get unsaved :committee-meeting/meeting-agenda-template-ref)]
                             (some #(when (= (:db/id %) v) %) templates))
                           (:committee-meeting/meeting-agenda-template-ref meeting))]
    [:div.mb-4
     [ui-add/add-widget
      {:title   [:span.normal-case (tr [:meetings/edit-meeting])]
       :buttons [{:text     (tr [:cancel])
                  :on-click #(do (>evt [::ee/cancel-changes meeting-id])
                                 (>evt [::meetings-subs/hide-edit-meeting meeting-id]))}
                 {:disabled? disabled?
                  :on-click  #(>evt [::meetings-subs/save-meeting meeting-id])
                  :text      (tr [:save])}]}

      [:div.flex.flex-row.gap-4.items-end
       [:div.flex-1
        [ui/date-picker {:label-text (tr [:meetings/date])
                         :required?  true
                         :callback   #(>evt [::ee/set-value
                                             meeting-id
                                             :committee-meeting/date
                                             (if (and date (some? %))
                                               (date-util/set-hours-and-minutes % (.getHours date) (.getMinutes date))
                                               %)])
                         :value      date}]]
       [:div.flex-1
        [ui/time-input {:label-text (tr [:meetings/time])
                        :on-change  (fn [[hour minute]]
                                      (>evt [::ee/set-value
                                             meeting-id
                                             :committee-meeting/date
                                             (date-util/set-hours-and-minutes
                                               (or (date-util/start-of-day date) (js/Date.))
                                               hour
                                               minute)]))
                        :value      (if date
                                      [(.getHours date) (.getMinutes date)]
                                      [12 0])}]]
       [:div.flex-1
        [ui-select/select {:id           (str "edit-meeting-agenda-template-" meeting-id)
                           :class-name   "full-width-select"
                           :label-text   (tr [:meetings/agenda-template])
                           :hide-label   false
                           :allow-empty? true
                           :select-text  (if default-template
                                           (str (tr [:meetings/default-template])
                                                " (" (:meeting-agenda-template/name default-template) ")")
                                           (tr [:meetings/select-template]))
                           :value        current-template
                           :values       templates
                           :val->str     :meeting-agenda-template/name
                           :on-change    #(>evt [::ee/set-value
                                                 meeting-id
                                                 :committee-meeting/meeting-agenda-template-ref
                                                 (when % (:db/id %))])}]]]

      [:hr.border-t.border-solid.border-ui-gray.my-4]

      [:div
       [:label.bx--label (tr [:meetings/notes])]
       [ui-rt/editor {:initial-value (:committee-meeting/description meeting)
                      :id            (str "edit-meeting-description-" meeting-id)
                      :on-change     #(>evt [::ee/set-value meeting-id :committee-meeting/description %])}]]]]))

;;; Expandable meeting rows

(defn- build-agenda-item [item lang]
  (let [workspace (:committee-item/item item)
        target    (workspace-model/workspace-target workspace)
        applicant (->> (party-model/active-parties-for-the-role target :role/applicant)
                       (map #(party-model/corporation-and-full-name-or-full-name % lang))
                       sort
                       (str/join ", "))]
    {:db/id      (:db/id item)
     :app-number (:workspace/id workspace)
     :category   (config-model/category-name workspace lang)
     :ws-status  (:domain/state target)
     :address    (:workspace/address workspace)
     :pin        (-> workspace :workspace/primary-property :property/id)
     :owner      applicant
     :_item      item}))

(defn- expanded-agenda-item [row]
  (let [tr              (<sub [:tr])
        item            (:_item row)
        workspace       (:committee-item/item item)
        phase-entity    (-> workspace workspace-model/workspace-target)
        remove-signal   [:process.signal/remove-workspace-from-meeting
                         {:meeting-item-id    (:db/id item)
                          :committee-group-id (-> item committee-model/meeting-item-group :db/id)}]
        remove-enabled? (<sub [::process-query/signal-allowed? (:entity/type phase-entity) (:workspace/id workspace) remove-signal])
        description     (:committee-item/description item)
        deficiencies    (:committee-item/deficiencies item)]
    [:div
     ;; Description (from committee item, if present)
     (when (and description (not (ui-rt/empty-texts? description)))
       [:<>
        [ui-sep/horizontal]
        [:div.px-4.py-2
         [:div.font-bold.mb-2 (tr [:meetings/description])]
         [ui-rt/editor {:initial-value description
                        :id            (str "agenda-desc-" (:db/id item))}]]])
     ;; Deficiencies (if any)
     (when (seq deficiencies)
       [:<>
        [ui-sep/horizontal]
        [:div.px-4.py-2
         [:div.font-bold.mb-2 (tr [:meetings/deficiencies])]
         [:table.w-full.my-2
          [:tbody
           (for [d deficiencies]
             ^{:key (:db/id d)}
             [:tr
              [:td.py-1 [ui-rt/editor {:initial-value (:inspection.deficiency/reference d)
                                       :id            (str "agenda-deficiency-ref-" (:db/id item) "-" (:db/id d))}]]
              [:td.py-1 [ui-rt/editor {:initial-value (:inspection.deficiency/description d)
                                       :id            (str "agenda-deficiency-desc-" (:db/id item) "-" (:db/id d))}]]])]]]])
     [:<>
      ;; Separator after Description/Deficiencies
      [ui-sep/horizontal]
      [:div.px-4.py-2.flex.items-center.gap-2
       (when ((du/in-state-fn :committee-item.state/postponed :committee-item.state/canceled) item)
         [:span.text-gray-600.font-bold.border.border-gray-400.rounded.px-2.py-1.text-sm
          (tr [(:domain/state item)])])
       [:div.flex-1]
       (if (<sub [::process/signal-processing? :process.signal/remove-workspace-from-meeting])
         (cc/loading-spinner {:small true :with-overlay false})
         (cc/button {:kind     :tertiary
                     :size     :small
                     :on-click #(let [phase-entity (-> item :committee-item/item workspace-model/workspace-target)
                                      group        (committee-model/meeting-item-group item)]
                                  (>evt [::process/signal
                                         phase-entity
                                         [:process.signal/remove-workspace-from-meeting
                                          {:meeting-item-id    (:db/id item)
                                           :committee-group-id (:db/id group)}]
                                         {:notify {:success :committee-item/removed}}]))
                     :disabled (not remove-enabled?)}
                    (tr [:meetings/remove-from-agenda])))
       (cc/button {:kind     :tertiary
                   :size     :small
                   :on-click #(let [workspace (:committee-item/item item)]
                                (futil/open-in-new-tab-or-window
                                  (href/href :view/workspace {:workspace-id (:workspace/id workspace)})))}
                  (tr [:meetings/go-to-workspace]))]]]))

(defn- agenda-table [tr meeting {:keys [close-meeting? active?]}]
  (let [lang         (<sub [:language])
        agenda-items (<sub [::committee-subs/agenda-items (:db/id meeting)])
        items        (->> agenda-items (mapv #(build-agenda-item % lang)))]
    [sortable-table/table
     {:id            (str "agenda-table-" (:db/id meeting))
      :tr            tr
      :headerless?   true
      :cols          (cond-> []
                       close-meeting?
                       (conj ["" (fn [row]
                                   (let [item-id (:db/id row)]
                                     [cc/checkbox {:id         (str "select-item-" item-id)
                                                   :label-text (tr [:select/select])
                                                   :hide-label true
                                                   :checked    (<sub [::committee-subs/item-selected? item-id])
                                                   :on-change  (fn [_]
                                                                 (>evt [::committee-subs/toggle-item-selected item-id]))}]))
                              {:width "50px"}])
                       true
                       (into [["" :app-number]
                              ["" :category]
                              ["" (fn [row] (some-> row :ws-status vector tr))]
                              ["" :address]
                              ["" :pin]
                              ["" :owner]])
                       close-meeting?
                       (conj ["" (fn [row]
                                   (let [item-id   (:db/id row)
                                         action-kw (<sub [::committee-subs/selected-action item-id])
                                         postpone? (:postpone? (committee-model/end-meeting-actions action-kw))]
                                     (when action-kw
                                       [:span.font-bold {:class (if postpone? "text-ui-red" "text-ui-green")}
                                        (translate-action tr action-kw)])))]))
      :on-reorder    (when (and active? (not close-meeting?))
                       (fn [from to]
                         (>evt [::committee-subs/reorder-agenda from to])))
      :items         items
      :expanded-func expanded-agenda-item}]))

(defn- check-signals-permitted [agenda-items]
  (when (seq agenda-items)
    (>evt [::process-query/check-signals-permitted
           (->> agenda-items
                (reduce (fn [acc item]
                          (let [workspace     (:committee-item/item item)
                                remove-signal [:process.signal/remove-workspace-from-meeting
                                               {:meeting-item-id    (:db/id item)
                                                :committee-group-id (-> item committee-model/meeting-item-group :db/id)}]]
                            (assoc-in acc
                                      [(:workspace/id workspace)
                                       (-> workspace workspace-model/workspace-target :entity/type)]
                                      #{remove-signal})))
                        {}))])))

(defn- expanded-meeting [tr meeting]
  (let [meeting-id        (:db/id meeting)
        edit-status       (<sub [::meetings-subs/edit-meeting-status meeting-id])
        edit-visible?     (= edit-status :visible)
        mode              (<sub [::committee-subs/mode meeting-id])
        close-meeting?    (= mode :close)
        active?           (= (:domain/state meeting) :committee-meeting.state/active)
        agenda-items      (<sub [::committee-subs/agenda-items meeting-id])
        item-ids          (set (map :db/id agenda-items))
        selected-item-ids (<sub [::committee-subs/selected-items])]
    [:div
     (when edit-visible?
       [:div.px-4.py-2
        [edit-meeting {:meeting meeting}]])

     ;; Section 2: Description + template when overridden
     (when-not edit-visible?
       (let [template-override (:committee-meeting/meeting-agenda-template-ref meeting)]
         [:<>
          [ui-sep/horizontal]
          [:div.px-4.py-2
           [:div.font-bold.mb-2 (tr [:meetings/description])]
           [:div (or (when-let [description (:committee-meeting/description meeting)]
                       [ui-rt/editor {:initial-value description
                                      :id            (str "meeting-desc-" meeting-id)}])
                     (tr [:meetings/no-description]))]
           (when template-override
             [:div.mt-2
              [:span.font-bold (tr [:meetings/agenda-template]) ": "]
              [:span (:meeting-agenda-template/name template-override)]])]]))

     (when (and close-meeting?
                (seq agenda-items))
       [:div.mb-6.sticky.top-15.bg-ui-white.z-10
        [ui-action-bar/action-bar
         {:actions [{:description (tr [:multi-select/select-all])
                     :disabled    (<sub [::committee-subs/all-selected? meeting-id])
                     :on-click    #(>evt [::committee-subs/set-selection item-ids])}
                    {:description (tr [:multi-select/select-none])
                     :disabled    (<sub [::committee-subs/none-selected?])
                     :on-click    #(>evt [::committee-subs/set-selection #{}])}]}
         (if (<sub [::process-query/loading?])
           (cc/loading-spinner {:small true :with-overlay false})
           [ui-select/select {:id              "meeting-end-action-select"
                              :values          (sort-by (partial translate-action tr) (<sub [::committee-subs/possible-actions-for-selected]))
                              :disabled-values (<sub [::committee-subs/disabled-actions-for-selected])
                              :val->str        (partial translate-action tr)
                              :value           (<sub [::committee-subs/selected-action-for-selection])
                              :inline-label?   true
                              :label-text      (tr [:committee-meeting/set-workspace-as])
                              :allow-empty?    false
                              :on-change       (fn [action-def]
                                                 (>evt [::committee-subs/select-action
                                                        selected-item-ids
                                                        action-def]))}])]])

     ;; Section 3: Agenda
     [ui-sep/horizontal]
     [:div.px-4.py-2
      (when (seq agenda-items)
        [:<>
         [:div.font-bold.mb-2 (tr [:meetings/agenda])]
         [agenda-table tr meeting {:close-meeting? close-meeting? :active? active?}]])
      [:div.flex.gap-2.mt-2
       (cc/button {:kind     :tertiary
                   :size     :small
                   :href     (str "/api/command/committee/download-agenda?meeting-id=" meeting-id)
                   :download ""
                   :icon     i/download}
                  (tr [:meetings/create-agenda]))
       (cc/button {:kind     :tertiary
                   :size     :small
                   :href     (str "/api/command/committee/download-meeting-pkg?meeting-id=" meeting-id)
                   :download ""
                   :icon     i/download}
                  (tr [:meetings/create-meeting-packets]))]]

     (when active?
       [:<>
        [ui-sep/horizontal]
        [:div.px-4.py-2.flex.justify-end.gap-2
         (when-not close-meeting?
           [:<>
            (if edit-visible?
              (cc/button {:kind     :tertiary
                          :size     :small
                          :on-click #(do (>evt [::ee/cancel-changes meeting-id])
                                         (>evt [::meetings-subs/hide-edit-meeting meeting-id]))}
                         (tr [:cancel]))
              (cc/button {:kind     :tertiary
                          :size     :small
                          :on-click #(>evt [::meetings-subs/show-edit-meeting meeting-id])}
                         (tr [:meetings/edit-meeting])))
            [committee-view/change-meeting-button
             (util/mmap {:command :committee/cancel-meeting
                         :event   ::committee-subs/cancel-meeting
                         :kind    :tertiary
                         :confirm (tr [:committee-meeting/cancel-confirm])}
                        meeting-id)]])
         (if close-meeting?
           [:div
            (cc/button {:on-click #(>evt [::committee-subs/set-mode meeting-id :default])
                        :kind     :tertiary}
                       (tr [:cancel]))
            [committee-view/change-meeting-button
             (util/mmap {:command         :committee/complete-meeting
                         :tr-key          :committee/ok
                         :event           ::committee-subs/complete-meeting
                         :additional-data (<sub [::committee-subs/additional-complete-meeting-data meeting-id])}
                        meeting-id)]]
           (cc/button {:on-click (fn [_]
                                   (>evt [::committee-subs/set-mode meeting-id :close])
                                   (>evt [::process-query/check-signals-permitted
                                          (->> agenda-items
                                               (map :committee-item/item)
                                               (reduce (fn [acc workspace]
                                                         (let [target (workspace-model/workspace-target workspace)]
                                                           (if target
                                                             (assoc-in acc
                                                                       [(:workspace/id workspace)
                                                                        (:entity/type target)]
                                                                       committee-subs/meeting-close-signals)
                                                             acc)))
                                                       {}))]))
                       :kind     :primary
                       :size     :small}
                      (tr [:meetings/complete-meeting])))]])]))


(defn- meetings-filters [tr lang meetings group-id]
  (let [filters (<sub [::meetings-subs/meetings-filters])
        types   (->> meetings
                     (keep :entity/parent)
                     (reduce (fn [acc c] (assoc acc (:db/id c) c)) {})
                     vals
                     (sort-by #(committee-model/committee-name % lang)))]
    [:div.flex.flex-wrap.gap-2.my-4
     [ui-ms/multi-select
      {:id          "meetings-filter-department"
       :label-text  (tr [:meetings/department])
       :hide-label? true
       :value       (:departments filters)
       :values      (<sub [::meetings-subs/committee-authority-groups group-id])
       :class-name  "w-full min-w-64"
       :wrap-text?  true
       :val->str    :group/name
       :on-change   #(>evt [::meetings-subs/set-meetings-filter :departments %])}]

     [ui-ms/multi-select
      {:id          "meetings-filter-status"
       :label-text  (tr [:meetings/status])
       :hide-label? true
       :value       (:statuses filters)
       :values      (->> meetings
                         (map :domain/state)
                         set)
       :class-name  "w-full min-w-64"
       :wrap-text?  true
       :val->str    #(if (= % :committee-meeting.state/passed)
                       (tr [:committee-meeting/completed])
                       (tr [%]))
       :on-change   #(>evt [::meetings-subs/set-meetings-filter :statuses %])}]

     [ui-ms/multi-select
      {:id          "meetings-filter-type"
       :label-text  (tr [:meetings/type])
       :hide-label? true
       :value       (->> types
                         (filter #(contains? (:meeting-types filters) (:db/id %))))
       :values      types
       :class-name  "w-full min-w-64"
       :wrap-text?  true
       :val->str    #(committee-model/committee-name % lang)
       :on-change   #(>evt [::meetings-subs/set-meetings-filter :meeting-types (du/entity-id-set %)])}]

     [:div.flex.flex-row.flex-wrap.gap-2
      [ui/date-picker {:hide-label  true
                       :placeholder (tr [:meetings/date-from])
                       :value       (:date-from filters)
                       :callback    #(>evt [::meetings-subs/set-meetings-filter :date-from %])}]
      [:span.self-center "\u2013"]
      [ui/date-picker {:hide-label  true
                       :placeholder (tr [:meetings/date-to])
                       :value       (:date-to filters)
                       :callback    #(>evt [::meetings-subs/set-meetings-filter :date-to %])}]]]))

(defn group-names [meeting]
  (->> meeting
       committee-model/meeting-authority-groups
       (map :group/name)
       sort))

(defn group-col [tr]
  [(tr [:meetings/department])
   (fn [meeting]
     (futil/for-frag [group (group-names meeting)]
       [ui/tag {:type  :round
                :color :blue}
        group]))
   {:sorting (fn [& meeting-pair]
               (->> meeting-pair
                    (map (comp (partial str/join " ") group-names))
                    (apply compare)))}])

(defn view [_]
  (let [group-id       (<sub [::gas/group-id])
        tr             (<sub [:tr])
        lang           (<sub [:language])
        format-dt      (<sub [::date-util/date-time-fn])
        meetings       (<sub [::meetings-subs/all-meetings group-id])
        filtered       (<sub [::meetings-subs/filtered-meetings group-id])
        meetings-by-id (into {} (map (juxt :db/id identity)) filtered)
        widget-open?   (= :visible (<sub [::committee-subs/add-meeting-status nil]))]
    [:div.cloudpermit-page
     ;; Page heading
     [:div.bx--row.page-heading
      [:div.bx--col-xs-12>h1 (tr [:view/meetings])]]

     [:div.bx--row
      [:div.bx--col-xs-12
       [:div.bg-white.p-4

        [:div.flex
         (when (not widget-open?)
           (cc/button {:kind     :tertiary
                       :on-click #(>evt [::committee-subs/show-add-meeting nil])}
                      (tr [:meetings/create-meeting-button])))]

        ;; Add-meeting widget
        [committee-common/add-widget
         {:state (<sub [::committee-subs/add-meeting-status nil])}
         [add-meeting (util/mmap group-id)]]

        ;; Horizontal separator
        [:hr.border-t.border-solid.border-ui-dark-gray.my-4]

        ;; Filter row
        [meetings-filters tr lang meetings group-id]

        ;; Meetings table
        (if (<sub [::meetings-subs/loading?])
          (cc/loading-spinner {:small true :with-overlay false})
          [sortable-table/table
           {:id                "meetings-table"
            :tr                tr
            :get-status        (fn [meeting]
                                 (case (:domain/state meeting)
                                   :committee-meeting.state/passed :ok
                                   :committee-meeting.state/cancelled :inactive
                                   :primary))
            :cols              [[(tr [:meetings/items])
                                 (fn [meeting] (-> meeting committee-model/meeting-items count))
                                 {:sorting true}]
                                [(tr [:meetings/status])
                                 (fn [meeting]
                                   (let [state (:domain/state meeting)]
                                     [ui/tag {:type       :round
                                              :class-name (case state
                                                            :committee-meeting.state/passed "bg-ui-green text-ui-white"
                                                            :committee-meeting.state/cancelled "bg-ui-gray text-gray-600"
                                                            "bg-ui-night-sky-100 text-ui-white")}
                                      (if (= state :committee-meeting.state/passed)
                                        (tr [:committee-meeting/completed])
                                        (tr [state]))]))
                                 {:sorting (fn [& meetings]
                                             (->> meetings
                                                  (map (comp tr vector :domain/state))
                                                  (apply compare)))}]
                                [(tr [:meetings/date-time])
                                 (fn [meeting] (some-> meeting :committee-meeting/date format-dt))
                                 {:sorting true}]
                                (group-col tr)
                                [(tr [:meetings/type])
                                 (fn [meeting] (some-> meeting :entity/parent (committee-model/committee-name lang)))
                                 {:sorting true}]
                                [(tr [:meetings/description])
                                 (fn [meeting] (some-> meeting :committee-meeting/description rich-text/html-to-text))
                                 {:sorting true}]]
            :items             filtered
            :empty-placeholder (tr [:meetings/no-meetings])
            :on-expand         (fn [meeting-id expanded?]
                                 (when expanded?
                                   (some-> (meetings-by-id meeting-id)
                                           committee-model/meeting-items
                                           check-signals-permitted)))
            :expanded-func     (fn [meeting]
                                 [expanded-meeting tr meeting])}])]]]]))

(def route
  {:name        :view/meetings
   :view        view
   :parameters  {:path  {:group-id s/Int}
                 :query {(s/optional-key :committee-id) s/Int}}
   :controllers [{:parameters {:path [:group-id] :query [:committee-id]}
                  :start      (fn [{{:keys [group-id]}     :path
                                    {:keys [committee-id]} :query}]
                                (>evt [::meetings-subs/fetch-committees-and-meetings group-id])
                                (>evt [::meetings-subs/set-meetings-filter
                                       :meeting-types
                                       (when committee-id #{committee-id})]))}]})
